import React from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';

export default class Menu extends React.Component {
    render() {
        let catInv = [{id:'servicios',nombre:'Servicios'},{id:'actividades',nombre:'Actividades'},{id:'clientes',nombre:'Clientes'}];
        let movInv = [{id:'diario',nombre:'Actividades diarias'}];
        let conInv = [{id:'kardexUsu',nombre:'Actividades por usuario'},{id:'kardexCte',nombre:'Actividades por cliente'}];
        let repInv = [{id:'rptKardexUsu',nombre:'Actividades por usuario'},{id:'rptKardexCte',nombre:'Actividades por cliente'},{id:'rptKardexAct',nombre:'Resumen por Servicios'}];


        let modulos = [
                       {id:"inv", nombre:"Opciones", catalogos:catInv, movimientos:movInv, consultas:conInv, reportes:repInv}
                    ];
                    
        let config = {
          id:"conf", 
          nombre:"Configuracion", 
          opciones: [
            {id:'usuarios',nombre:'Usuarios'}
          ]
        };
    
        return (
            <ul className="nav">
                {modulos.map((e,i) =>{
                    return(
                        <li className="nav-item">
                            <Modulo modulo={e} opcionSeleccionada={this.props.opcionSeleccionada}/>
                        </li>    
                    )
                })}
                <ModuloSimple modulo={config} opcionSeleccionada={this.props.opcionSeleccionada}/>
            </ul>)
    }
}

class Modulo extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }
  onClick = (e) =>{
      this.toggle();
      //alert(e.target.dataset.opc);
      this.props.opcionSeleccionada(e.target.dataset.opc,e.target.innerText);
  }
  render() {
    const {modulo} = this.props;
    const titulo = modulo.nombre;
    const idMod = modulo.id;
    const catalogos = modulo.catalogos;
    const movimientos = modulo.movimientos;
    const consultas = modulo.consultas;
    const reportes = modulo.reportes;
    return (
      <div>
          <a  id={idMod} className="nav-link opcion" href="#">
          {titulo}
        </a>
        <Popover placement="bottom" isOpen={this.state.popoverOpen} target={idMod} toggle={this.toggle} trigger="legacy" style={{width:400}}>
          <PopoverBody className="body" style={{padding:1}}>
              <div className="container" style={{padding:1}}>
                <div className="body" style={{padding:5}}>
                  <div className="row">
                      <div className="col">
                        <span><b>catalogos</b></span>
                        <ul>
                            {catalogos.map((e,i) => <li className="opcionMenu" data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                        <span><b>Movimientos</b></span>
                        <ul>
                            {movimientos.map((e,i) => <li className="opcionMenu" data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                        <span><b>Consultas</b></span>
                        <ul>
                            {consultas.map((e,i) => <li className="opcionMenu" data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                       </div>
                      <div className="col">
                        <span><b>Informes</b></span>
                        <ul>
                            {reportes.map((e,i) => <li className="opcionMenu" data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                      </div>
                  </div>
                  </div>
              </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}

class ModuloSimple extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }
  onClick = (e) =>{
      this.toggle();
      //alert(e.target.dataset.opc);
      this.props.opcionSeleccionada(e.target.dataset.opc,e.target.innerText);
  }
  render() {
    const {modulo} = this.props;
    const titulo = modulo.nombre;
    const idMod = modulo.id;
    const opciones = modulo.opciones;
    return (
      <div>
          <a  id={idMod} className="nav-link opcion" href="#">
          {titulo}
        </a>
        <Popover placement="bottom" isOpen={this.state.popoverOpen} target={idMod} toggle={this.toggle} trigger="legacy" style={{width:400}}>
          <PopoverBody className="body" style={{padding:1}}>
              <div className="container" style={{padding:1}}>
                <div className="body" style={{padding:5}}>
                  <div className="row">
                      <div className="col">
                        <ul>
                            {opciones.map((e,i) => <li data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                      </div>
                  </div>
                  </div>
              </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}